<template>
  <div class="container mescroll-touch">
    <div class="coverBox">
      <img class="cover" v-if="cover" :src="cover" />
      <div class="info">
        <p class="title van-multi-ellipsis--l2">{{ title }}</p>
      </div>
    </div>
    <div class="loading" v-if="loading">
      <van-loading size="22px" text-size="14px">加载中...</van-loading>
    </div>
    <div class="contentBox" v-else>
      <div class="ForwardPosterBox">
        <img class="ForwardPosterBtn" @click="generatePoster" src="../../assets/images/ForwardPoster.png" />
        <img class="newGif" v-if="isNew" src="../../assets/images/newGif.gif" />
      </div>
      <template v-if="!loading && list.length > 0">
        <p class="total">共{{ total }}个内容</p>
        <div class="timeline">
          <div class="timeline-item" v-for="(item, index) in list" :key="index">
            <div class="timeline-marker"></div>
            <div class="timeline-content">
              <div class="live-time">{{ item.Start }}</div>
              <div class="live-item" v-for="(children, childrenIndex) in item.crd" :key="childrenIndex" @click="toContentPage(children.Id, children.Type)">
                <div class="live-cover">
                  <img :src="children.Thumbnail" alt="">
                  <img class="playIcon" src="@/assets/images/play_comm_icon@2x.png" />
                </div>
                <div class="live-info">
                  <p class="live-title van-multi-ellipsis--l2">{{ children.Title }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <NoData v-else/>
    </div>
    <div class="goback" @click="goback"><van-icon name="arrow-left" />返回列表</div>
    <van-popup class="PosterPopup" v-model="PosterShow" :close-on-click-overlay="false" @opened="generateImageOpened">
        <div class="close" @click="PosterShow = false">
          <van-icon class="closeIcon" name="cross" />
        </div>
        <div class="PosterBox">
          <div class="generateImageBox" ref="generateImageBox" v-if="!PosterPhoto">
            <img class="PosterImg" v-if="cover" :src="cover" />
            <div class="QrcodeBox">
              <img class="QrcodeFont" src="@/assets/images/font1.png" />
              <img class="Qrcode" crossOrigin="anonymous" v-if="QRCode" :src="QRCode" />
              <img class="QrcodeFont" src="@/assets/images/font2.png" />
            </div>
          </div>
          <img class="PosterPhoto" v-else :src="PosterPhoto" alt="">
          <p class="tips">请长按保存图片到手机后转发</p>
        </div>
    </van-popup>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import html2canvas from 'html2canvas';
import NoData from '../../components/noData.vue'
import { mapState } from "vuex";
export default {
  name: 'ActivityDetails',
  data() {
    return {
      hasPath: '',
      cover: '',
      title: '',
      QRCode: '',
      list: [],
      total: 0,
      loading: true,
      isNew: false,
      PosterShow: false,
      PosterPhoto: ''
    }
  },
  components: {
    NoData
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.hasPath = from.path;
    });
  },
  computed: {
    ...mapState(["userInfo"]),
    id() {
      return this.$route.query.id;
    },
    sourceType() {
      return this.$route.query.sourceType
    },
    sourceId() {
      return this.$route.query.sourceId
    }
  },
  created() {
    this.getActivityDetails();
    this.getHandleState();
    this.getList();
  },
  activated(){
    this.enter();
    wx.miniProgram.postMessage({
      data: {
        share: {
          title: '活动详情页',
          imageUrl: '',
          path: `/pages/oneSurgery/oneSurgery?url=${encodeURIComponent(process.env.VUE_APP_BASE_URL + `/activityDetails?id=${this.id}&sourceType=7`)}`,
          contentId: this.id
        }
      }
    })
  },
  deactivated() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  methods: {
    getHandleState() {
      this.$axios.post("/Api/Api/Web/Article/HandleState", {
        ArticleId: parseInt(this.id),
        CustomerId: this.userInfo.Id
      }).then((res) => {
        let data = res.Data;
        this.isNew = !data.some(item => item.type == 11);
      })
    },
    getActivityDetails() {
      this.$axios.get('/Api/Api/Web/Article/GetActDetile?id=' + this.id).then(res => {
        let data = res.Data;
        this.cover = data.Img;
        this.title = data.Title;
        this.QRCode = data.QrCode;
      })
    },
    getList() {
      this.$axios.post('/Api/Api/Web/Article/GetCorrelation ', {
        ActId: this.id,
        PageIndex: 1,
        PageSize: 1000
      }).then((res) => {
        this.list = res.Data.List;
        this.total = 0;
        this.list.forEach(item => {
          this.total += item.crd.length;
        });
        this.loading = false;
      })
    },
    enter() {
      this.$axios.post("/Api/Api/Web/Article/Handle", {
        ArticleId: parseInt(this.id),
        CustomerId: this.userInfo.Id,
        type: 1,
        Source: this.sourceType ? this.sourceType : 0,
        externalID: this.sourceId ? this.sourceId : ''
      }).then((res) => {
        if (!this.timer && res.Data != 0) {
          this.timer = setInterval(() => {
            this.$axios.post("/Api/Api/Web/Article/ABUpdateTime?id=" + res.Data).then(() => {});
          }, 10000);
        }
      });
    },
    toContentPage(id, type) {
      if(type == 3) {
        this.$router.push({
          path: 'liveDetails',
          query: {
            id: id
          }
        });
      } else {
        this.$router.push({
          path: 'contentPage',
          query: {
            id: id,
            type: type
          }
        });
      }
    },
    goback() {
      if(this.hasPath == '/' ) {
        this.$router.push('/activityList');
        return;
      }
      this.$router.go(-1);
    },
    generatePoster() {
      this.imageUrls = this.cover;
      this.PosterShow = true;
      this.$axios.post("/Api/Api/Web/Article/Handle", {
        ArticleId: parseInt(this.id),
        CustomerId: this.userInfo.Id,
        Type: 11,
        Source: this.sourceType ? this.sourceType : 0,
        externalID: this.sourceId ? this.sourceId : ''
      }).then((res) => {
        this.getHandleState();
      });
    },
    // generateImageOpened() {
    //   let toast = this.$toast.loading({
    //     message: '生成中...',
    //     forbidClick: true,
    //   });
    //   html2canvas(this.$refs.generateImageBox, {
    //     useCORS: true
    //   }).then((canvas) => {
    //     this.PosterPhoto = canvas.toDataURL("image/png");
    //     toast.clear();
    //   });
    // },
    generateImageOpened() {
      let toast = this.$toast.loading({
        message: '生成中...',
        forbidClick: true,
      });
      
      // 等待所有图片加载完成
      this.$nextTick(async () => {
        const images = this.$refs.generateImageBox.querySelectorAll('img');
        const imagePromises = Array.from(images).map(img => {
          return new Promise((resolve) => {
            if (img.complete && img.naturalHeight !== 0) {
              resolve();
            } else {
              img.onload = resolve;
              img.onerror = resolve; // 即使出错也继续
            }
          });
        });
        
        try {
          // 等待所有图片加载（或出错）
          await Promise.all(imagePromises);
          
          // 给一个延迟确保 DOM 稳定
          await new Promise(resolve => setTimeout(resolve, 500));
          
          html2canvas(this.$refs.generateImageBox, {
            useCORS: true,
            allowTaint: true, // 允许 tainted canvas
            backgroundColor: null, // 透明背景
            scale: 2, // 提高清晰度
          }).then((canvas) => {
            this.PosterPhoto = canvas.toDataURL("image/png");
            toast.clear();
          }).catch(error => {
            console.error('html2canvas 错误:', error);
            toast.clear();
            this.$toast('生成海报失败，请重试');
          });
          
        } catch (error) {
          toast.clear();
          console.error('图片等待错误:', error);
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  min-height: 100%;
  background-color: #F9F9F9;
  .coverBox {
    position: relative;
    .cover {
      display: block;
      width: 100%;
    }
    .info {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 20px 10px 10px;
      background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6));
      color: #FFFFFF;
      .title {
        font-size: 15px;
        font-weight: bold;
        text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);
      }
      .time {
        font-size: 10px;
      }
    }
  }
  .contentBox {
    position: relative;
  }
  .ForwardPosterBox {
    position: absolute;
    right: 0;
    top: 0px;
    .ForwardPosterBtn {
      width: 100px;
    }
    .newGif {
      width: 30px;
      position: absolute;
      right: 0px;
      bottom: 23px;
    }
  }
  .total {
    font-size: 12px;
    color: #554C47;
    margin: 15px;
  }
  .timeline {
    width: 100%;
    margin: 0 auto;
    padding: 0 10px 10px;
    box-sizing: border-box;
  }
  .timeline-item {
    display: flex;
    margin-bottom: 15px;
    position: relative;
    // border: 1px solid red;
  }
  .timeline-marker {
    width: 8px;
    height: 8px;
    background-color: #EB1700;
    border-radius: 50%;
    margin-right: 8px;
    flex-shrink: 0;
    position: relative;
    z-index: 1;
  }
  .timeline-content {
    .live-time {
      position: relative;
      top: -5px;
      color: #554C47;
      font-size: 12px;
    }
    .live-item {
      display: flex;
      border-radius: 8px;
      .live-cover {
        position: relative;
        width: 50%;
        margin-right: 8px;
        img {
          display: block;
          width: 100%;
        }
        .playIcon {
          display: block;
          position: absolute;
          bottom: 5px;
          right: 5px;
          width: 20px;
          opacity: 0.5;
        }
      }
      .live-info {
        position: relative;
        flex: 1;
        color: #554C47;
        .live-title {
          font-size: 13px;
        }
        .live-doctor {
          font-size: 11px;
        }
      }
    }
    .live-item:not(:last-child) {
      margin-bottom: 10px;
    }
  }
  .timeline-item::before {
    content: '';
    position: absolute;
    left: 3px;
    top: 0;
    width: 1px;
    height: calc(100% + 22px);
    background: #EB1700;
    z-index: 0;
  }
  .timeline-item:last-child::before {
    display: none;
  }
  .goback {
    position: fixed;
    bottom: 250px;
    right: 0;
    width: 70px;
    height: 24px;
    border-radius: 24px 0 0 24px;
    line-height: 24px;
    text-align: center;
    background: linear-gradient(to right, #EB1700 0%, #C33BBB 60%, #8C3BBB 100%);
    font-size: 12px;
    color: #FFFFFF;
  }
  .loading {
    text-align: center;
    margin-top: 30px;
  }
}

.PosterPopup {
  width: 90%;
  height: 350px;
  border-radius: 14px;
  overflow-y: visible;
}
.close {
  position: absolute;
  top: -7px;
  right: -7px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 50%;
  background-image: linear-gradient(130deg, #EB1700 50%, #C33BBB 80%, #8C3BBB 100%);
  z-index: 99;
  .closeIcon {
    color: #FFFFFF;
  }
}
.PosterBox {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  border-radius: 14px;
  .generateImageBox {
    padding-bottom: 10px;
  }
  .PosterImg {
    display: block;
    width: 100%;
  }
  .QrcodeBox {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    .QrcodeFont {
      width: 60px;
    }
  }
  .Qrcode {
    display: block;
    width: 100px;
    margin: 0 30px ;
  }
  .PosterPhoto {
    display: block;
    width: 100%;
  }
  .tips {
    font-size: 13px;
    color: #333333;
    margin: 0 0 18px;
    text-align: center;
  }
}
</style>
